import { useStaticMapUrl } from '@tribeplatform/react-sdk/hooks'

import { Link } from '../../Link/Link.js'

import { MapImageRenderer } from './MapImageRenderer.js'
import { generateGoogleMapsUrl } from './utils.js'

const FALLBACK_LAT = 22.54992
const FALLBACK_LNG = 0

interface MapViewProps {
  latitude: number
  longitude: number
  placeId: string
}

export const LocationMap = ({
  latitude = FALLBACK_LAT,
  longitude = FALLBACK_LNG,
  placeId,
}: MapViewProps) => {
  const { data: urls, isLoading } = useStaticMapUrl({
    variables: {
      input: {
        height: 200,
        width: 1000,
        location: {
          latitude,
          longitude,
        },
        placeId,
        scale: 2,
        zoom: 15,
      },
    },
  })
  const mapUrl = generateGoogleMapsUrl(latitude, longitude, placeId)
  const showLoading = !urls?.darkUrl && !urls?.lightUrl && isLoading

  return (
    <Link href={mapUrl} target="_blank" className="w-full">
      {showLoading ? (
        <div className="h-full w-full bg-surface-subdued animate-pulse rounded-base" />
      ) : (
        <MapImageRenderer
          latitude={latitude}
          longitude={longitude}
          placeId={placeId}
          urls={urls}
        />
      )}
    </Link>
  )
}
